import React from 'react'

export default function ReportsDashboard() {
	return (
		<React.Fragment></React.Fragment>
	)
}